import React from 'react';
import {NeuroMessage} from '@ignitesales/neuro-application';
import {MessagePropTypes} from "../utils/propTypes.mjs";

const LandingPageTitle = props => {
    return ( <NeuroMessage id='landing.title' tagName="h1" {...props} /> );
};
LandingPageTitle.propTypes = MessagePropTypes;

const LandingPageMessage = props => {
    return ( <NeuroMessage id='landing.message' shouldHideIfNotFound={true} tagName="p" {...props} /> );
};
LandingPageMessage.propTypes = MessagePropTypes;

export {
    LandingPageTitle,
    LandingPageMessage,
    LandingPageTitle as WelcomeTitle,
    LandingPageMessage as WelcomeMessage
};
